import {
  ready,
  forEachNode,
  addCssClass,
  removeCssClass,
  toggleCssClass,
  bindClickEvent,
  bindClickEventWithPreventDefault
} from '@/shared'

class MenuTopModule {
  DefaultHeader = 'Kategorie'

  CollapsibleSelector = '.js-menu-top-collapsible'
  MobileCollapsibleSelector = '.js-menu-top-mobile-collapsible'
  TriggerSelector = '.js-menu-top-trigger'
  NavigationSelector = '.js-menu-top-navigation'
  CloseMenuSelector = '.js-menu-top-close'
  ResetMenuSelector = '.js-menu-top-reset-menu'
  HeaderElementSelector = '.js-menu-top-header'

  DropDownActiveCssClass = 'is-dropdown-active'
  MenuOpenCssClass = 'is-active'
  NavigationOpenedCssClass = 'is-nav-opened'
  HideCssClass = 'hidden'

  constructor (selector) {
    this.element = document.querySelector(selector)
    if (!this.element) {
      throw new Error(`Menu top element not found. Selector: ${selector}`)
    }

    this.isNavigationOpened = false
    this.mqTable = window.matchMedia('screen and (max-width: 1200px)')
  }

  mount () {
    this._bindElements()
    this._bindEvents()
    this._hideDropdownsOnMobile()
    this._calculateDesktopSubmenu()
    this._openCurrentMobile()
  }

  _bindElements () {
    this.navigationElement = this.element.querySelector(this.NavigationSelector)
    this.triggerElement = this.element.querySelector(this.TriggerSelector)
    this.headerElement = this.element.querySelector(this.HeaderElementSelector)
    this.resetMenuElement = this.element.querySelector(this.ResetMenuSelector)
    this.navigationElement = this.element.querySelector(this.NavigationSelector)
    this.mobileCollapsible = this.element.querySelectorAll(this.MobileCollapsibleSelector)
    this.body = document.querySelector('body')
  }

  _bindEvents () {
    bindClickEventWithPreventDefault(this.element, this.TriggerSelector, this._toggleMenu.bind(this))
    bindClickEvent(this.element, this.CollapsibleSelector, this._toggleCollapsibleElement.bind(this))
    bindClickEvent(this.element, this.MobileCollapsibleSelector, this._handleMobileCollapsibleClicked.bind(this))
    bindClickEventWithPreventDefault(this.element, this.CloseMenuSelector, this._closeMenu.bind(this))
    bindClickEventWithPreventDefault(this.element, this.ResetMenuSelector, this._resetMenu.bind(this))
  }

  _handleMobileCollapsibleClicked (options) {
    if (this.mqTable.matches) {
      options.e.preventDefault()
      this._toggleCollapsibleElement(options)
    }
  }

  _hideDropdownsOnMobile () {
    if (this.mqTable.matches) {
      forEachNode(this.mobileCollapsible, (node) => {
        const nested = node.parentNode.querySelectorAll(this.CollapsibleSelector)
        const nestedCount = nested.length

        if (nestedCount >= 5) {
          forEachNode(nested, (node) => {
            removeCssClass(node.parentNode, this.DropDownActiveCssClass)
          })
        }
      })
    }
  }

  _resetMenu (options) {
    removeCssClass(options.node.closest('.is-dropdown'), this.DropDownActiveCssClass)
    if (options.node.closest('.overlow-hidden')) {
      removeCssClass(options.node.closest('.overlow-hidden'), 'overlow-hidden')
    }
  }

  _toggleMenu () {
    if (!this.isNavigationOpened) {
      this._openMenu()
    } else {
      this._closeMenu()
    }
  }

  _openMenu () {
    this.isNavigationOpened = true
    addCssClass(this.triggerElement, this.MenuOpenCssClass)
    addCssClass(this.navigationElement, this.NavigationOpenedCssClass)
    addCssClass(this.body, this.NavigationOpenedCssClass)
  }

  _closeMenu () {
    this.isNavigationOpened = false
    removeCssClass(this.triggerElement, this.MenuOpenCssClass)
    removeCssClass(this.navigationElement, this.NavigationOpenedCssClass)
    removeCssClass(this.body, this.NavigationOpenedCssClass)
  }

  _toggleCollapsibleElement ({node, e}) {
    if (this.mqTable.matches || node.getAttribute('data-dropdown') === 'always') {
      document.getElementsByClassName('c-nav-main-list')[0].scrollTo(0, 0)
      for (var i = 0; i < document.getElementsByClassName('c-nav-main-list__box').length; i++) {
        document.getElementsByClassName('c-nav-main-list__box')[i].scrollTo(0, 0)
      }
      for (var j = 0; j < document.getElementsByClassName('children-menu-mobile').length; j++) {
        document.getElementsByClassName('children-menu-mobile')[j].scrollTo(0, 0)
      }
      e.preventDefault()
      if (node.closest('.is-dropdown-active')) {
        toggleCssClass(node.closest('.is-dropdown-active'), 'overlow-hidden')
      }
      toggleCssClass(node.closest('.is-dropdown'), this.DropDownActiveCssClass)
      this._showResetButton()
    }
  }

  _getHeaderText (node) {
    return node.getAttribute('data-header')
  }

  _showResetButton () {
    removeCssClass(this.resetMenuElement, this.HideCssClass)
  }

  _hideResetButton () {
    addCssClass(this.resetMenuElement, this.HideCssClass)
  }
  _calculateDesktopSubmenu () {
    let menu = this.mobileCollapsible
    function menuPostion () {
      setTimeout(function () {
        var marginRight = (window.innerWidth - 1200) / 2
        forEachNode(menu, (node) => {
          var elementClass = node.closest('.menu-item-relative').nextElementSibling
          removeCssClass(elementClass, 'right')
          if (window.innerWidth < elementClass.getBoundingClientRect().right + marginRight) {
            if ((node.getBoundingClientRect().right - elementClass.offsetWidth) > 100) {
              addCssClass(elementClass, 'right')
            } else {
              removeCssClass(elementClass, 'right')
            }
          } else {
            removeCssClass(elementClass, 'right')
          }
        })
      }, 200)
    }
    menuPostion()

    window.addEventListener('resize', function () {
      menuPostion()
    })
  }
  _openCurrentMobile () {
    if (document.querySelector('.c-breadcrumbs-list') !== null) {
      let categories = document.querySelector('.c-breadcrumbs-list').querySelectorAll('a')
      let mobileCategory = document.querySelector('.c-nav-main-list').querySelectorAll('[data-header]')
      mobileCategory.forEach(item => {
        let textName = item.getAttribute('data-header')
        textName = textName.trim()
        let itemHTML = item.innerHTML.replace(/<span[^>]*>([^<]+)<\/span>/g, '')
        // eslint-disable-next-line no-undef
        if (itemHTML.trim() === nameCategory) {
          item.classList.add('selected-page')
        }
        // eslint-disable-next-line no-undef
        if (idCategory !== 337) {
          categories.forEach(item2 => {
            let textName2 = item2.text
            textName2 = textName2.trim()
            if (this.mqTable.matches) {
              if (textName === textName2) {
                if (item.getAttribute('href') === window.location.href.split('?')[0] || item.getAttribute('href') === window.location.pathname) {
                  item.classList.add('current-menu')
                }
                if (item.nextElementSibling && item.nextElementSibling.classList.contains('js-menu-top-mobile-collapsible')) {
                  item.classList.add('current-menu')
                  item.nextElementSibling.click()
                }
              }
            }
          })
        } else {
          categories.forEach(item2 => {
            let textName2 = item2.text
            textName2 = textName2.trim()
            if (this.mqTable.matches) {
              if (textName === textName2) {
                if (item.getAttribute('href') === window.location.href.split('?')[0] || item.getAttribute('href') === window.location.pathname) {
                  item.classList.add('current-menu')
                }
              }
            }
          })
        }
      })
    }
  }
}

function headerFixed () {
  window.addEventListener('load', (event) => {
    var getOffsetTop = function (elem) {
      var distance = 0
      if (elem.offsetParent) {
        do {
          distance += elem.offsetTop
          elem = elem.offsetParent
        } while (elem)
      }
      return distance < 0 ? 0 : distance
    }
    var headerElement = document.getElementsByClassName('header-outer')
    headerElement = headerElement[0]
    var stuck = false
    var stickPoint = getDistance()
    let offsetTop, headerElement2
    if (document.getElementsByClassName('l-product__fixed').length > 0) {
      let actionsWrapper = document.getElementsByClassName('l-product__actions')
      offsetTop = getOffsetTop(actionsWrapper[0])
      headerElement2 = document.getElementsByClassName('l-product__fixed')
      headerElement2 = headerElement2[0]
    }
    function scroll () {
      if (document.getElementsByClassName('l-product__fixed').length > 0) {
        var distance = window.pageYOffset
        if (distance > offsetTop) {
          headerElement2.classList.add('fixed')
        } else {
          headerElement2.classList.remove('fixed')
        }
      }
    }
    function getDistance () {
      var topDist = headerElement.offsetTop
      return topDist
    }
    function scrollheader () {
      var distance = getDistance() - window.pageYOffset
      var offset = window.pageYOffset
      if ((distance <= 0) && !stuck) {
        headerElement.classList.add('fixed')
        stuck = true
      } else if (stuck && (offset <= stickPoint)) {
        headerElement.classList.remove('fixed')
        stuck = false
      }
    }

    window.onscroll = function (e) {
      scrollheader()
      scroll()
    }
    if (document.getElementsByClassName('l-product__fixed').length > 0) {
      let fixedTitle = document.getElementsByClassName('l-product__fixed-title')
      let productTitle = document.getElementsByClassName('l-product__title-product')
      fixedTitle[0].addEventListener('click', () => {
        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: getOffsetTop(productTitle[0]) - 60
        })
      })
    }
  })
}

// function productFixed () {
//   var getOffsetTop = function (elem) {
//     var distance = 0
//     if (elem.offsetParent) {
//       do {
//         distance += elem.offsetTop
//         elem = elem.offsetParent
//       } while (elem)
//     }
//     return distance < 0 ? 0 : distance
//   }
//   window.addEventListener('load', (event) => {
//     let actionsWrapper = document.getElementsByClassName('l-product__actions')
//     let offsetTop = getOffsetTop(actionsWrapper[0])
//     var headerElement2 = document.getElementsByClassName('l-product__fixed')
//     headerElement2 = headerElement2[0]
//     function scroll() {
//       var distance = window.pageYOffset
//       if (distance > offsetTop) {
//         headerElement2.classList.add('fixed')
//       } else {
//         headerElement2.classList.remove('fixed')
//       }
//     }

//     window.onscroll = function (e) {
//       scroll()
//     }
//   })
// }

function pagesIndicator () {
  if (window.innerWidth > 1200) {
    // only desktop
    var loader = document.querySelector('.js-loader')
    var selectorClick = document.querySelectorAll('.js-nav-categories-scroll a,.brands_list_item a,.c-actions-list a,.selectProductSort-selectBox-dropdown-menu a,.c-pagination-list a,.footer_links a,#js-menu-top .c-nav-alt-list a, .c-cart-actions__item:not(.cart) a, .category .categories_tree_block a, .product_desc a, .js-product-name, .product_img_link, .c-breadcrumbs-list a, .c-logo, #footer-articles-wrapper, .stlinkgroups_links_footer a, .c-social-list a, a.c-product-box, .js-dropdown a, .myaccount_lnk_list a, .js-menu-top-mobile-collapsible, .js-menu-top-collapsible, .c-nav-main-list__label, .c-nav-primary-list__label-wrap,.c-nav-main-list__item.promotion .c-btn--theme-4, #submit_searchbox,.c-product-box__title a, .c-product-box__pic a')

    for (let i = 0; i < selectorClick.length; i++) {
      selectorClick[i].addEventListener('click', function () {
        setTimeout(function () {
          loader.classList.add('is-active')
        }, 200)
      })
    }
    window.onbeforeunload = function () {
      setTimeout(function () {
        loader.classList.add('is-active')
      }, 200)
    }
  } else if (window.matchMedia('(display-mode: standalone)').matches) {
    var selectorClick2 = document.querySelectorAll('.l-sec--head__prev,.js-nav-categories-scroll a,.brands_list_item a,.c-actions-list a,.selectProductSort-selectBox-dropdown-menu a,.c-pagination-list a,.footer_links a,#js-menu-top .c-nav-alt-list a, .c-cart-actions__item:not(.cart) a, .category  .categories_tree_block a, .product_desc a, .js-product-name, .product_img_link, .c-breadcrumbs-list a, .c-logo, #footer-articles-wrapper, .stlinkgroups_links_footer a:not(.visible-phone), .c-social-list a, a.c-product-box, .js-dropdown a, .myaccount_lnk_list a ,.c-nav-main-list__label:not(.js-menu-top-mobile-collapsible), .c-nav-primary-list__label-wrap:not(.js-menu-top-collapsible), .c-nav-main-list__item.promotion .c-btn--theme-4, #submit_searchbox, .c-product-box__title a, .c-product-box__pic a')
    for (let i = 0; i < selectorClick2.length; i++) {
      selectorClick2[i].addEventListener('click', function () {
        setTimeout(function () {
          loader.classList.add('is-active')
        }, 200)
      })
    }
    window.onbeforeunload = function () {
      setTimeout(function () {
        loader.classList.add('is-active')
      }, 200)
    }
  }
}

ready(function () {
  headerFixed()
  pagesIndicator()
  new MenuTopModule('#js-menu-top').mount()
  // eslint-disable-next-line no-undef
  jQuery('.toggle-description').on('click', function (e) {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    jQuery(this).toggleClass('open')
    // eslint-disable-next-line no-undef
    jQuery(this).closest('.listing_short_description_outer').find('.l-box').slideToggle()
  })
})



// WEBPACK FOOTER //
// ./src/menu-top.js